<template>
  <div>
    <div>
      <div v-for="(item, index) in itemList" :key="index">
        <h2 class="column-title">{{ formatTitle(item) }}</h2>
        <ModuleIteration
          :pageStatus="pageStatus"
          :controlData="mapAttributeModel(item)"
          :language="language"
          :selectProductType="selectProductType"
          v-model="formData[item]"
        />
        <el-divider />
      </div>
      <!-- RevisionDate -->
      <h2 class="column-title">{{ languageText("RevisionDate") }}</h2>
      <RevisionComponents
        :revisionList="revisionData"
        :pageStatus="pageStatus"
        :language="language"
      ></RevisionComponents>

      <el-divider />
      <NotesComponents
        :selectProductType="selectProductType"
        :otherNotesData="otherNotesData"
        :language="language"
      ></NotesComponents>
      <!-- 添加Verify打印信息 -->
      <el-divider />
      <div>
        <el-checkbox v-model="isPrintVerify">{{
          languageText("Print Please Verify")
        }}</el-checkbox>
      </div>

      <el-divider />
      <!-- 操作按钮 -->
      <OptionsButton
        :pageStatus="pageStatus"
        :isPrintSignature="isPrintVerify"
        :language="language"
      />
    </div>
    <el-backtop target=".content" :bottom="100">
      <div>{{ languageText("UP") }}</div>
    </el-backtop>
  </div>
</template>

<script>
import ModuleIteration from "./ModuleIteration.vue";
import RevisionComponents from "./components/RevisionComponents.vue";
import OptionsButton from "./OptionsButton.vue";
import NotesComponents from "./components/NotesComponents.vue";

export default {
  props: {
    itemList: Array,
    formData: Object,
    revisionData: Array,
    pageStatus: String,
    selectProductType: String,
    otherNotesData: Object,
    language: String,
  },
  components: {
    ModuleIteration,
    RevisionComponents,
    OptionsButton,
    NotesComponents,
  },
  data() {
    return {
      isPrintVerify: false,
      mappingTitle: [
        { key: "base_info", value: "基础信息" },
        { key: "general_specification", value: "产品信息" },
        { key: "analysis", value: "分析项目" },
        { key: "microbiological_tests", value: "微生物测试" },
        { key: "fatty_acid", value: "脂肪酸" },
        { key: "other_notes", value: "其他信息" },
      ],
    };
  },
  inject: ["getControlDataMethod"],
  methods: {
    languageText: function (key) {
      let mappingLanage = [
        {
          english: "UP",
          chinese: "上",
        },
        {
          english: "Print Please Verify",
          chinese: "打印客户签名栏",
        },
        {
          english: "RevisionDate",
          chinese: "修订记录",
        },
      ];
      if (this.language == "CN") {
        let foundItem = mappingLanage.find((item) => item.english == key);
        if (foundItem) {
          return foundItem.chinese;
        } else {
          // 如果没有找到对应的中文翻译，返回英文原文
          return key;
        }
      }
      return key;
    },
    formatTitle(str) {
      if (this.language == "CN") {
        let foundItem = this.mappingTitle.find((item) => item.key == str);
        if (foundItem) {
          return foundItem.value;
        } else {
          // 如果没有找到对应的中文翻译，返回格式化的英文
          return str
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (match) => match.toUpperCase());
        }
      }
      return str
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (match) => match.toUpperCase());
    },
    mapAttributeModel(str) {
      let dataAttr =
        str.replace(/_([a-z])/g, (g) => g[1].toUpperCase()) + "Data";
      let data = this.getControlDataMethod(dataAttr);
      return data;
    },
  },
  created() {
    console.info("revisionData--:", this.revisionData);
    // console.info("this.itemList:", this.itemList);
    // console.info('this.formData:',this.formData)
  },
};
</script>
